"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecommendationError = void 0;
/**
 * <h4>Recommendation errors</h4>
 *
 * @packageDocumentation
 */
var RecommendationError_1 = require("./RecommendationError");
Object.defineProperty(exports, "RecommendationError", { enumerable: true, get: function () { return RecommendationError_1.RecommendationError; } });
//# sourceMappingURL=index.js.map